import Api from '@/services/Api'

export default {
  getUsers (token) {
    return Api().get('users/')
  },
  getSalesUsers () {
    return Api().get('getSalesUsers/')
  },
  updatePassword (params) {
    return Api().post('updatePassword/', params)
  },
  updateUser (params) {
    return Api().put('user/' + params._id, params)
  }
}



// WEBPACK FOOTER //
// ./src/services/UserService.js